import classNames from "classnames";
import type { RelationshipFieldset } from "@/entities/form-metadata";
import { useIsNewRelationshipEnabled } from "../useIsNewRelationshipEnabled";
import styles from "./AddNewFamilyMemberButton.module.scss";

interface AddNewFamilyMemberButtonProps {
    fieldset: RelationshipFieldset;
    onItemAdded: (fieldset: RelationshipFieldset) => void;
}

export const AddNewFamilyMemberButton = ({ fieldset, onItemAdded }: AddNewFamilyMemberButtonProps) => {
    const isDisabled = useIsNewRelationshipEnabled({ fieldset });

    return (
        <button
            type="button"
            className={classNames(styles.addRelation, "link headerLink")}
            disabled={isDisabled}
            onClick={() => onItemAdded(fieldset)}
            data-testid={`add-family-member-${fieldset.relation}`}
        >
            {fieldset.label}
        </button>
    );
};
